
import { Queue } from "@/types/queue";
import { Clock, Users, Timer } from "lucide-react";

interface QueueStatsProps {
  queue: Queue;
}

export function QueueStats({ queue }: QueueStatsProps) {
  const formatTime = (minutes: number | null) => {
    if (!minutes) return "0 min";
    if (minutes < 60) return `${minutes} min`;
    const hours = Math.floor(minutes / 60);
    const remainingMinutes = minutes % 60;
    return `${hours}h ${remainingMinutes}m`;
  };

  return (
    <div className="grid grid-cols-2 md:grid-cols-3 gap-4 mb-8">
      <div className="space-y-2 p-4 rounded-xl bg-secondary shadow-sm border border-muted/30">
        <div className="flex items-center justify-center text-accent">
          <Clock size={20} />
        </div>
        <div className="text-2xl font-bold text-center animate-number-change">
          #{queue.current_number || 0}
        </div>
        <div className="text-xs text-center text-muted-foreground font-medium">
          Current Number
        </div>
      </div>

      <div className="space-y-2 p-4 rounded-xl bg-secondary shadow-sm border border-muted/30">
        <div className="flex items-center justify-center text-accent">
          <Users size={20} />
        </div>
        <div className="text-2xl font-bold text-center animate-number-change">
          {queue.people_in_queue || 0}
        </div>
        <div className="text-xs text-center text-muted-foreground font-medium">
          In Queue
        </div>
      </div>

      <div className="space-y-2 p-4 rounded-xl bg-secondary shadow-sm border border-muted/30">
        <div className="flex items-center justify-center text-accent">
          <Timer size={20} />
        </div>
        <div className="text-2xl font-bold text-center animate-number-change">
          {formatTime(queue.avg_wait_time)}
        </div>
        <div className="text-xs text-center text-muted-foreground font-medium">
          Average Wait Time
        </div>
      </div>
    </div>
  );
}
